import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
//import { createCustomer } from "../services/createCustomer";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../environment";
//import Loader from "../Components/Loader";
import Swal from "sweetalert2";
import Select from "react-select";
import { ChipSet, Chip } from "@material/react-chips";
import withReactContent from "sweetalert2-react-content";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const EditQuestions = ({ history, match }) => {
    const [question, setQuestion] = useState("");
    const [dap_option_name, setoption_name] = useState("");
    const [team, setteam] = useState("");
    const [question_type_id, setQuestionTypeId] = useState("");
    const [dap_state, setState] = useState("");
    const [question_type, setQuestionType] = useState("");
    const [masterId, setMasterId] = useState("");
    const [masterType, setMasterType] = useState("");
    const [options, setOption] = useState([]);
    const [weightage, setWeightage] = useState("");
    const [industryId, setindustryId] = useState("");
    const [industryType, setindustryType] = useState("");
    const [inputList, setInputList] = useState([{ option: "", waitage: "" }]);
    const [checkBoxOptions, setCheckBoxOptions] = useState([]);
    const [checkBoxCustomOptions, setCheckBoxCustomOptions] = useState([]);

    const [teamErrors, setTeamErrors] = useState({});
    const [questionTypeErrors, setQuestionTypeErrors] = useState({});
    const [questionErrors, setQuestionsErrors] = useState({});
    const [answerTypeErrors, setAnswerTypeErrors] = useState({});

    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let id = match.params.id;
        axios
            .get(environment.dap_url + "questionnarieApi/getQuestionByid?id=" + id)
            .then((res) => {
                console.log(res.data);
                // setQuestionDetail(res.data);
                // handleShow();
                setteam(res.data[0].team);
                setMasterType(master_dropdown[res.data[0].questionMasterId - 1].questionMasterName);
                setMasterId(master_dropdown[res.data[0].questionMasterId - 1].questionMasterId);
                setindustryId(industriestype[res.data[0].industryId || 0].roleId );
                setindustryType(industriestype[res.data[0].industryId || 0].roleType );
                setQuestion(res.data[0].question);
                setQuestionType(res.data[0].questionType);
                setQuestionTypeId(res.data[0].questionTypeId);
                // setOption(res.data[0].answerOptions);
                setWeightage(res.data[0].waitage);
                setInputList(res.data[0].answerOptions);
            })
            .catch(function (error) {
                MySwal.fire({
                    title: <p>{error.message}</p>,
                    type: "error",
                });
            });
    }, [match.params.id]);
    let master_dropdown = [];
    master_dropdown = [
    {
      questionMasterName: "Awareness",
      questionMasterId: 1,
    },
    {
      questionMasterName: "Current Usage Experience",
      questionMasterId: 2,
    },
    {
      questionMasterName: "Voluntary Questions",
      questionMasterId: 3,
    },
  ];
    let teams_dropdown = [];
    teams_dropdown = [
        {
            team: "Sales",
            team_id: "Sales",
        },
        {
            team: "Support",
            team_id: "Support",
        },
    ];
    let question_array_before = [];
    question_array_before = [
        {
            type: "Yes/No Type",
            questionTypeId: 1,
        },
        {
            type: "Option Based",
            questionTypeId: 2,
        },

        {
            type: "Descriptive",
            questionTypeId: 3,
        },
        {
            type: "Checkbox",
            questionTypeId: 4,
        },
        {
            type: "Checkbox with custom input",
            questionTypeId: 5,
        },
        {
            type: "Ranking",
            questionTypeId: 6,
        },
        {
            type: "Option with custom input",
            questionTypeId: 7,
        },
    ];

    let question_array_feedback = [];
    question_array_feedback = [
        {
            type: "Yes/No Type",
            questionTypeId: 1,
        },
        {
            type: "Option Based",
            questionTypeId: 2,
        },
        {
            type: "Descriptive",
            questionTypeId: 3,
        },
        // {
        //   type: "Checkbox",
        //   questionTypeId: 4,
        // },
        // {
        //   type: "Checkbox with custom input",
        //   questionTypeId: 5,
        // },
        // {
        //   type: "Ranking",
        //   questionTypeId: 6,
        // },
        // {
        //   type: "Option with custom input",
        //   questionTypeId: 7,
        // },
    ];

    let industriestype = [];
    industriestype = [
        {
        roleType: "All",
        roleId: 0,
        },
        {
        roleType: "Corporate",
        roleId: 1,
        },
        {
        roleType: "Education",
        roleId: 2,
        },
        {
        roleType: "Healthcare",
        roleId: 3,
        },
        {
        roleType: "Hospitality",
        roleId: 4,
        },
        {
        roleType: "Manufacturing",
        roleId: 5,
        },
        {
        roleType: "Others",
        roleId: 6,
        },
    ];

    const formValidation = () => {
        setTeamErrors({});
        setQuestionTypeErrors({});
        setQuestionsErrors({});
        setAnswerTypeErrors({});

        let isValid = true;

        if (team.length == 0) {
            setTeamErrors({ noTeam: 'Please select a team' });
            isValid = false;
        }

        if (!masterId) {
            setQuestionTypeErrors({ noQuestion: 'Please select feedback question type' });
            isValid = false;
        }

        if (industryId === null || industryId === undefined || industryId === '') {
            setQuestionTypeErrors({ noQuestion: 'Please select industry type' });
            isValid = false;
        }

        if (question.trim().length == 0) {
            setQuestionsErrors({ noQuestion: 'Please enter question' });
            isValid = false;
        }

        if (!question_type_id) {
            setAnswerTypeErrors({ noAnswer: 'Please select answer type' });
            isValid = false;
        }

        if ((question_type_id !== 1 && question_type_id !== 3) && inputList.some((item) => item.option.trim() === "")) {
            setAnswerTypeErrors({ noWeightage: 'Please enter option' });
            isValid = false;
        }
        
        console.log(isValid);
        return isValid;
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        const isValid = formValidation();
        if (isValid) {
            setLoading(true);
            await axios
                .put(
                    environment.dap_url +
                    // "user?sendActivationMail=true&entityGroupId=49942ab0-0f9a-11ec-aeab-6338f3fa1c68",
                    "questionnarieApi/updateQuestionWithId",
                    {
                        _id: match.params.id,
                        question: question.trim(),
                        questionTypeId: question_type_id,
                        questionType: question_type,
                        questionMasterId: masterId,
                        industryId: industryId,
                        answerOptions: inputList,
                        waitage: weightage,
                        team: team,
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.message) {
                        MySwal.fire({
                            title: <p>Duplicate Question</p>,
                            type: "error",
                        });
                        setLoader(false);
                        setLoading(false);
                    } else {
                        MySwal.fire({
                            title: <p>Question has been successfully updated!</p>,
                            type: "success",
                        });
                        setMasterType("");
                        setindustryId("");
                        setindustryType("");
                        setQuestionType("");
                        setInputList([{ option: "", waitage: "" }]);
                        setQuestion("");
                        setWeightage("");
                        setOption("");
                        setLoader(false);
                        setLoading(false);

                        history.push("/questions");
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    MySwal.fire({
                        title: (
                            <p>
                                {err?.response?.data?.message || "Question creation failed"}
                            </p>
                        ),
                        type: "error",
                    });
                });
        } else {
            MySwal.fire({
                title: <p>Please fill the required Fields</p>,
                type: "error",
            });
            setLoader(false);
            setLoading(false);
        }
    };

    const setQuestionHandler = (e) => {
        console.log(e);
        console.log(e.id);
        setQuestionTypeId(e.id);
        setQuestionType(e.label);
        if (e.id === 1 || e.id === 3) {
            setInputList([]); // Set inputList to an empty array
        } else {
            setInputList([{ option: "", waitage: "" }]); // Set inputList to a default option
            setWeightage(null);
        }
    };

    const setMasterHandler = (e) => {
        console.log(e);
        setMasterId(e.id);
        setMasterType(e.label);
    };

    const appendInput = (e) => {
        e.preventDefault();
        console.log("add");
        console.log(options);
        let options_to_append = [];
        options_to_append.push(options);

        console.log(options_to_append);
    };

    // handle input change
    const handleInputChange = (e, index) => {
        e.preventDefault();
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
        let input_arr = [];

        inputList.forEach((i) => {
            if (i.option_name) {
                input_arr.push({
                    option: i.option_name,
                    waitage: Number(i.waitage_val),
                });
            }
        });
        console.log(input_arr);
        setOption(input_arr);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (e, index) => {
        e.preventDefault();
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        setInputList([...inputList, { option: "", waitage: "" }]);
    };

    // // handle click event of the Add button
    // const handleAddClick = (e) => {
    //   e.preventDefault();
    //   setInputList([...inputList, { input: "", waitage: "" }]);
    //   let input_arr = [];

    //   inputList.forEach((i) => {
    //     if (i.input) {
    //       input_arr.push(i.input);
    //     }
    //   });
    //   console.log(input_arr);
    //   setOption(input_arr);
    // };
    console.log(team.length);

    console.log(question_type_id);
    console.log("this is inputlist", inputList);
    return (
        <>
            <div>
                <NavbarNew />
                <div className="row">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                        <Link to="/questions" className="btn btn-light my-3">
              Go Back
            </Link>
                    </div>
                    <div className="col-lg-3"></div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-3"></div>
                    <div className="col-md-6 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h1 className="text-center">EDIT QUESTION</h1>
                                <Form>
                                    <Form.Group controlId="name">
                                        <Form.Label>Team *</Form.Label>
                                        <Select
                                            options={teams_dropdown.map((element) => ({
                                                value: element.team,
                                                label: element.team,
                                                id: element.team_id,
                                            }))}
                                            onChange={(e) =>
                                                //setMasterId(element.questionMasterId)
                                                setteam(e.value)
                                            }
                                            value={{ label: team }}
                                            // defaultValue={dap_deviceList[0].name}
                                            placeholder={"Team"}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="name">
                                        <Form.Label>Feedback Question Type *</Form.Label>
                                        <Select
                                            options={master_dropdown.map((element) => ({
                                                value: element.questionMasterName,
                                                label: element.questionMasterName,
                                                id: element.questionMasterId,
                                            }))}
                                            onChange={(e) =>
                                                //setMasterId(element.questionMasterId)
                                                setMasterHandler(e)
                                            }
                                            value={{ label: masterType }}
                                            // defaultValue={dap_deviceList[0].name}
                                            defaultValue="hi there"
                                            placeholder={masterType}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="name">
                                        <Form.Label>Industry *</Form.Label>
                                        <Select
                                        options={industriestype.map((element) => ({
                                            value: element.roleType,
                                            label: element.roleType,
                                            id: element.roleId,
                                        }))}
                                        onChange={(e) => {
                                            setindustryId(e.id);
                                            setindustryType(e.label);
                                            }
                                        }
                                        // defaultValue={dap_deviceList[0].name}
                                        defaultValue="Select Industry type"
                                        placeholder={industryType}
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="title">
                                        <Form.Label>Question *</Form.Label>
                                        <Form.Control
                                            type="question"
                                            placeholder="Enter question"
                                            value={question}
                                            onChange={(e) => setQuestion(e.target.value)}
                                        ></Form.Control>
                                    </Form.Group>

                                    <>
                                        <div>
                                            {masterId === 1 ? (
                                                <Form.Group controlId="name">
                                                    <Form.Label>Answer Type *</Form.Label>
                                                    <Select
                                                        options={question_array_feedback.map((element) => ({
                                                            value: element.type,
                                                            label: element.type,
                                                            id: element.questionTypeId,
                                                        }))}
                                                        onChange={(e) => setQuestionHandler(e)}
                                                        // defaultValue={dap_deviceList[0].name}
                                                        defaultValue="hi there"
                                                        placeholder={question_type}
                                                    />
                                                </Form.Group>
                                            ) : (
                                                <Form.Group controlId="name">
                                                    <Form.Label>Answer Type *</Form.Label>
                                                    <Select
                                                        options={question_array_before.map((element) => ({
                                                            value: element.type,
                                                            label: element.type,
                                                            id: element.questionTypeId,
                                                        }))}
                                                        onChange={(e) => setQuestionHandler(e)}
                                                        // defaultValue={dap_deviceList[0].name}
                                                        defaultValue="hi there"
                                                        placeholder={question_type}
                                                    />
                                                </Form.Group>
                                            )}
                                        </div>
                                    </>

                                    {masterId === 1 && (
                                        <>
                                            {question_type_id === 1 || question_type_id === 3 ? (
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="title">
                                                        <Form.Label>Enter Question Weightage</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            placeholder="Enter Question Weightage"
                                                            value={weightage}
                                                            onChange={(e) =>
                                                                setWeightage(Number(e.target.value))
                                                            }
                                                        ></Form.Control>
                                                    </Form.Group>
                                                </div>
                                            ) : null}
                                        </>
                                    )}

                                    {question_type_id === 2 ||
                                        question_type_id === 4 ||
                                        question_type_id === 5 ||
                                        question_type_id === 6 ||
                                        question_type_id === 7 ? (
                                        <>
                                            {inputList.map((x, i) => {
                                                return (
                                                    <div className="row" key={i}>
                                                        <div className="col-lg-4">
                                                            <Form.Control
                                                                name="option"
                                                                placeholder="Enter Option"
                                                                value={x.option}
                                                                onChange={(e) => handleInputChange(e, i)}
                                                                style={{ marginTop: "5px" }}
                                                            />
                                                        </div>

                                                        <div className="col-lg-4">
                                                            <Form.Control
                                                                type="number"
                                                                className="ml10"
                                                                name="waitage"
                                                                placeholder="Enter weightage"
                                                                value={x.waitage}
                                                                onChange={(e) => handleInputChange(e, i)}
                                                                style={{ marginTop: "5px" }}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2">
                                                            {inputList.length !== 1 && (
                                                                <div
                                                                    onClick={(e) => handleRemoveClick(e, i)}
                                                                    style={{ marginTop: "5px" }}
                                                                >
                                                                    <i className="mdi mdi-window-close"></i>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {inputList.length - 1 === i && (
                                                            <div style={{ marginTop: "10px", marginLeft: "10px" }}>
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={handleAddClick}
                                                                >
                                                                    Add More
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </>
                                    ) : null}

                                    {/* {question_type_id === 6 ? (
                    <Form.Group controlId='option'>
                      <Form.Label>Check Box with custom options</Form.Label>
                      <Form.Control
                        type='question'
                        placeholder='Enter check box options separated by comma'
                        value={options}
                        onChange={(e) =>
                          setCheckBoxCustomOptions(e.target.value)
                        }
                      ></Form.Control>
                    </Form.Group>
                  ) : null} */}

                                    <div className="mt-3">
                                        <Button
                                            type="submit"
                                            className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                                            disabled={loading}
                                            onClick={submitHandler}
                                        >
                                            Update Question
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                            )}
                                            {loading && <span></span>}
                                            {!loading && <span></span>}
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3"></div>
                </div>
            </div>
        </>
    );
};

export default EditQuestions;
